import styled from 'styled-components';

export const Container = styled.ul`
  list-style: none;
  padding: 0;
`;

export const Fallback = styled.h2`
  color: white;
  text-align: center;
`;
